'use client';
import { useParams } from 'next/navigation';
import React from 'react';
import {default as Image} from '@/components/global/images/resized-cdn-image';

import circleInfoBrand from '@/public/assets/images/global/alerts/circle-info-brand.svg';
import styles from '@/components/global/alerts/alert-brand.module.scss';
import { doTranslation } from '@/app/i18n/client';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  id?: string;
  title?: string;
  text?: string;
}

const AlertBrand = (props: Props): React.JSX.Element | null => {
  const { lng } = useParams() as { lng: string };
  const { t } = doTranslation(lng);
  return (
    <div className={styles.brand} id={props.id ?? ''}>
      <div className={styles.icon}>
        <div className={styles.info}>
          <Image alt={t('Circle Info Brand')} height="24" src={circleInfoBrand} width="24" />
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.header}>
          <span className={styles.title}>{props.title}</span>
        </div>
        <div className={styles.body}>
          <span className={styles.text}>{props.text}</span>
        </div>
      </div>
    </div>
  );
};

export default AlertBrand;
